import React, { Component } from "react";
import Select from "react-select";

export default class InputSelect extends Component {
  render() {
    const {
      label,
      margin,
      width = "100%",
      labelStyle,
      error,
      classLabel,
      ...rest
    } = this.props;
    return (
      <div style={{ margin, width }}>
        <div>
          {label && (
            <label style={labelStyle} className={classLabel}>
              {label}
            </label>
          )}
          <Select {...rest} />
        </div>
        {error && <small style={{ color: "red" }}>{error}</small>}
      </div>
    );
  }
}
